import classNames from "classnames"
import React, { useContext } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

import { ContactInvoicesContext } from "../ContactInvoicesContextProvider"

const Summary = () => {
  const { presentmentCurrency } = useMarina()
  const { summaryTotals } = useContext(ContactInvoicesContext)
  const { totalCents, paidCents, unpaidCents, dueNowCents } = summaryTotals

  const ROW_VARIANTS = {
    standard: "standard",
    large: "large",
  }

  const renderLabel = (label, variant) => (
    <div
      className={classNames("text-nowrap font-semibold", {
        "!text-lg font-bold": variant === ROW_VARIANTS.large,
      })}
    >
      {label}
    </div>
  )

  const renderValue = (label, value, variant) => {
    const labelForTestId = label.toLowerCase().replace(/\s/g, "-") // "DUE NOW" -> "due-now"; "TOTAL" -> "total"

    return (
      <div
        data-testid={`print-view-summary-${labelForTestId}-value`}
        className={classNames("break-all", {
          "!text-lg font-bold !text-red-600": variant === ROW_VARIANTS.large,
        })}
      >
        {formatCurrencyFromMinorUnits({
          amount: value,
          currency: presentmentCurrency,
        })}
      </div>
    )
  }

  const renderSummaryLine = ({
    label,
    value,
    variant = ROW_VARIANTS.standard,
  }) => (
    <>
      {renderLabel(label, variant)}
      {renderValue(label, value, variant)}
    </>
  )

  return (
    <div
      className="grid w-fit max-w-96 grid-cols-2 gap-x-8 gap-y-1 !bg-gray-200 p-4"
      data-testid="print-view-summary"
    >
      {renderSummaryLine({ label: "TOTAL", value: totalCents })}
      {renderSummaryLine({ label: "PAID", value: paidCents })}
      {renderSummaryLine({ label: "UNPAID", value: unpaidCents })}
      <div className="col-span-2 pt-4" />
      {renderSummaryLine({
        label: "DUE NOW",
        value: dueNowCents,
        variant: ROW_VARIANTS.large,
      })}
    </div>
  )
}

export default Summary
